import { render, staticRenderFns } from "./MFI_SettingsWindow.vue?vue&type=template&id=40e24530&scoped=true"
import script from "./MFI_SettingsWindow.vue?vue&type=script&lang=js"
export * from "./MFI_SettingsWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e24530",
  null
  
)

export default component.exports